module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-ekanban-tablet-d3e4b8f913da8fd5bd5af7647b826fdc.png";